import type { DrawingModel } from "./DrawingModel";
import { reviveDrawing } from "./registry";
import { uGet, uSet } from "../core/storage";

const KEY = (symbol: string) => `drawings.${symbol}`;

export function saveDrawings(symbol: string, drawings: DrawingModel[]) {
  try {
    const data = drawings.map((d) => d.serialize());
    uSet(KEY(symbol), JSON.stringify(data));
  } catch {}
}

export function loadDrawings(symbol: string): DrawingModel[] {
  try {
    const raw = uGet(KEY(symbol));
    if (!raw) return [];
    const data = JSON.parse(raw);
    if (!Array.isArray(data)) return [];
    return data.map(reviveDrawing).filter((d): d is DrawingModel => d !== null);
  } catch {
    return [];
  }
}
